import React from 'react';
import { AssetType } from '../types/Asset';
import styles from './AssetIcons.module.css';

export { ButtonWithIcon, CreateIcon, SaveIcon, SettingsIcon } from '../../../shared/components/ActionIcons';

type IconProps = {
  className?: string;
  size?: number;
};

const svgProps = (className: string | undefined, size: number) => ({
  className,
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none' as const,
  'aria-hidden': true,
  focusable: false as const,
});

export const PetIcon: React.FC<IconProps> = ({ className = styles.tabIcon, size = 16 }) => (
  <svg {...svgProps(className, size)} stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
    <ellipse cx="7.4" cy="8.2" rx="1.55" ry="2" />
    <ellipse cx="12" cy="6.4" rx="1.55" ry="2" />
    <ellipse cx="16.6" cy="8.2" rx="1.55" ry="2" />
    <ellipse cx="8.6" cy="12.4" rx="1.4" ry="1.7" />
    <path d="M9.1 17.2c1.1-2.4 2.3-3.1 3.4-3.1s2.3.7 3.4 3.1c.35.75-.15 1.65-1 1.9-1.5.45-3.15.45-4.65 0-.85-.25-1.35-1.15-1-1.9Z" />
  </svg>
);

export const VehicleIcon: React.FC<IconProps> = ({ className = styles.tabIcon, size = 16 }) => (
  <svg {...svgProps(className, size)} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.8 14.8v-2.1c0-.7.32-1.36.87-1.8L8.1 9.2A2 2 0 0 1 9.4 8.8h5.2a2 2 0 0 1 1.3.4l2.4 1.9c.55.44.87 1.1.87 1.8v1.9" />
    <path d="M3.8 14.8h16.4" />
    <circle cx="7.4" cy="16.4" r="1.55" />
    <circle cx="16.6" cy="16.4" r="1.55" />
    <path d="M9.2 8.8v2.6h5.6V8.8" />
  </svg>
);

export const PropertyIcon: React.FC<IconProps> = ({ className = styles.tabIcon, size = 16 }) => (
  <svg {...svgProps(className, size)} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.6 11.4 12 5.2l7.4 6.2" />
    <path d="M6.6 10.6V19h10.8v-8.4" />
    <path d="M10.2 19v-5.2h3.6V19" />
  </svg>
);

export const HouseIcon = PropertyIcon;

export const OtherAssetIcon: React.FC<IconProps> = ({ className = styles.tabIcon, size = 16 }) => (
  <svg {...svgProps(className, size)} stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round">
    <path d="M12 4.2 19 8.1v7.8L12 19.8 5 15.9V8.1L12 4.2Z" />
    <path d="M5 8.1 12 12l7-3.9M12 12v7.8" />
  </svg>
);

const TYPE_ICONS: Record<AssetType, React.FC<IconProps>> = {
  Pet: PetIcon,
  Vehicle: VehicleIcon,
  Property: PropertyIcon,
  Other: OtherAssetIcon,
};

export const AssetTypeIcon: React.FC<IconProps & { type: AssetType }> = ({ type, className = styles.tabIcon, size = 16 }) => {
  const Icon = TYPE_ICONS[type] || OtherAssetIcon;
  return <Icon className={className} size={size} />;
};
